// 背景 + 文字 有兩種類型 (1: 自訂背景 / 2: 預設背景)
export const froalaKeyVisionTypeMapping = {
    IMAGE: 1,
    COLOR: 2
};

export const coverImg = {
    default: 'https://assets.fevercdn.com/promotion/img/ugc_image/Cover1.svg',
    cover_one: 'https://assets.fevercdn.com/promotion/img/key_vision/cover_background_01.png',
    cover_two: 'https://assets.fevercdn.com/promotion/img/key_vision/cover_background_02.png',
    cover_ugc: 'https://assets.fevercdn.com/promotion/img/ugc_image/UGC_Cover.jpg'
};

// 主視覺尺寸比例

/**
 * 網頁背景：2880 x 1620 (px)、590 x 1280 (px)
 * 點數兌獎、UGC 作品集、多元發票登錄、個人點數歷程頁: 2880 x 600 (px)、590 x 250 (px)
 * 邀請好友任務、新客加入獎勵：2880 x 1200 (px)、590 x 400 (px)
 */
export const ratio = {
    background: {
        mobile: {
            width: 590,
            height: 1280
        },
        desktop: {
            width: 2880,
            height: 1620
        }
    },
    ugc: {
        mobile: {
            width: 590,
            height: 250
        },
        desktop: {
            width: 2880,
            height: 600
        }
    },
    promo: {
        mobile: {
            width: 590,
            height: 400
        },
        desktop: {
            width: 2880,
            height: 1200
        }
    }
};
